import List from 'containers/WorkingTypes/List';
import Edit from 'containers/WorkingTypes/Edit';
import Create from 'containers/WorkingTypes/Create';
import Show from 'containers/WorkingTypes/Show';

export default { List, Edit, Create, Show };
